import React, {useEffect, useState} from "react";

interface ImageProps {
    id: string | undefined;
}

const logos = import.meta.glob("../../../src/assets/images/logos/*.png", {
    eager: true,
    import: "default",
}) as Record<string, string>;

const OrganisationLogo: React.FC<ImageProps> = ({ id }) => {
    const [imageSrc, setImageSrc] = useState<string | null>(null);

    useEffect(() => {
        if (!id) {
            setImageSrc(null);
            return;
        }

        const imagePath = `../../../src/assets/images/logos/${id}.png`;
        setImageSrc(logos[imagePath] ?? null);
    }, [id]);

    if (!imageSrc) {
        return null;
    }

    return <img src={imageSrc} alt={`Image for ID ${id}`} className="h-[46px]" />;
};


export default OrganisationLogo;